import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const Header = ({ session }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <header className="bg-gradient-to-r from-white to-[#ffefc2] p-6 shadow-md">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img src="https://www.seedsai.co/_next/image?url=%2FseedsAILight.png&w=256&q=75" alt="SeedsAI Logo" className="h-8" />
          <span className="text-xl font-bold">X</span>
          <img src="https://upload.wikimedia.org/wikipedia/en/thumb/8/86/Jio_Financial_Services_Logo.svg/1200px-Jio_Financial_Services_Logo.svg.png" alt="JFS Logo" className="h-10" />
        </div>
        <nav className="flex space-x-4">
          {session ? (
            <>
              <Link to="/" className="bg-white/30 hover:bg-white/50 transition-colors duration-200 rounded-md px-3 py-2 border border-gray-400">
                <span className="text-black font-medium">📱All Apps</span>
              </Link>
              <Link to="/graphs" className="bg-white/30 hover:bg-white/50 transition-colors duration-200 rounded-md px-3 py-2 border border-gray-400">
                <span className="text-black font-medium">📈Graphs</span>
              </Link>
              <Link to="/scatter" className="bg-white/30 hover:bg-white/50 transition-colors duration-200 rounded-md px-3 py-2 border border-gray-400">
                <span className="text-black font-medium">🧩Feature Plot</span>
              </Link>
              <button onClick={handleLogout} className="bg-red-500 hover:bg-red-600 transition-colors duration-200 rounded-md px-3 py-2 border border-red-600">
                <span className="text-white font-medium">Logout</span>
              </button>
            </>
          ) : null}
        </nav>
      </div>
    </header>
  );
};

export default Header;
